import { render, staticRenderFns } from "./associateConfig.vue?vue&type=template&id=120dd952&scoped=true"
import script from "./associateConfig.vue?vue&type=script&lang=js"
export * from "./associateConfig.vue?vue&type=script&lang=js"
import style0 from "./associateConfig.vue?vue&type=style&index=0&id=120dd952&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120dd952",
  null
  
)

export default component.exports